import { jsx as c } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
const z = "_text_19q11_29", o = {
  text: z,
  "is-small": "_is-small_19q11_34",
  "is-ellipsis": "_is-ellipsis_19q11_38",
  "is-center": "_is-center_19q11_44",
  "color-primary": "_color-primary_19q11_47",
  "color-secondary": "_color-secondary_19q11_50",
  "color-tertiary": "_color-tertiary_19q11_53",
  "color-eco-green": "_color-eco-green_19q11_56",
  "color-success": "_color-success_19q11_59",
  "color-error": "_color-error_19q11_62",
  "color-inverted": "_color-inverted_19q11_65",
  "color-warning": "_color-warning_19q11_68",
  "color-inherit": "_color-inherit_19q11_71",
  "is-bold": "_is-bold_19q11_74",
  "size-xs": "_size-xs_19q11_77",
  "size-sm": "_size-sm_19q11_80",
  "size-base": "_size-base_19q11_83",
  "size-lg": "_size-lg_19q11_86",
  "size-xl": "_size-xl_19q11_89",
  "dialog-overlay-show": "_dialog-overlay-show_19q11_1",
  "dialog-content-show": "_dialog-content-show_19q11_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_19q11_1"
};
function w({
  children: t,
  dangerouslySetInnerHTML: s,
  isSmall: a,
  ellipsis: n,
  isSpan: q,
  className: d = "",
  color: _ = "primary",
  isBold: m,
  size: e,
  title: g,
  center: p,
  ...i
}) {
  const r = x(
    o.text,
    a && o["is-small"],
    n && o["is-ellipsis"],
    _ && o[`color-${_}`],
    m && o["is-bold"],
    e && o[`size-${e}`],
    p && o["is-center"],
    d
  ), l = q ? "span" : "div";
  return s ? /* @__PURE__ */ c(l, { className: r, dangerouslySetInnerHTML: s, ...i, title: g }) : /* @__PURE__ */ c(l, { className: r, ...i, children: t });
}
export {
  w as T,
  o as s
};
